import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { UtilService } from '@polaris-customerweb/sharedcomponents.core';
import { Garageable } from '@polaris-customerweb/sharedcomponents.garage/lib/models/garagable';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { AppState } from 'src/app/models/app-state';
import { UserAuthService } from '../user-auth/user-auth.service';

@Injectable({ providedIn: 'root' })
export class GarageItemsBrandRoutingService {
    constructor(
        protected configService: ConfigService,
        protected routingHelpersService: RoutingHelpersService,
        protected store: Store<AppState>,
        protected userAuthService: UserAuthService,
        protected utilService: UtilService
    ) {}

    getGarageItemBrandDomain(garageItem: Garageable): string {
        let brandDomain = '';
        const isSlingshotOrDomain = this.isSlingshotOrDomain(garageItem);
        const isOffRoadOrDomain = this.isOffRoadOrDomain(garageItem);
        const isIndianOrDomain = this.isIndianOrDomain(garageItem);

        if (this.configService.appSku !== 'IND' && isIndianOrDomain) {
            brandDomain = isIndianOrDomain;
        } else if (this.configService.appSku !== 'ORV' && isOffRoadOrDomain) {
            brandDomain = isOffRoadOrDomain;
        } else if (this.configService.appSku !== 'SLG' && isSlingshotOrDomain) {
            brandDomain = isSlingshotOrDomain;
        }

        return brandDomain;
    }

    isIndianOrDomain(garageItem: Garageable): false | string {
        if (
            garageItem.isIndian ||
            garageItem.isOnBrand?.('IND') ||
            (garageItem.brand === 'gem' && garageItem.appSku === 'IND')
        ) {
            return this.routingHelpersService.combineUrl(
                this.configService.rideCommandUrl.indian,
                this.configService.baseHref
            );
        }
        return false;
    }

    isOffRoadOrDomain(garageItem: Garageable): false | string {
        if (
            garageItem.isOffRoad ||
            garageItem.isOnBrand?.('ORV') ||
            (garageItem.brand === 'gem' && garageItem.appSku === 'ORV')
        ) {
            return this.routingHelpersService.combineUrl(
                this.configService.rideCommandUrl.offRoad,
                this.configService.baseHref
            );
        }
        return false;
    }

    isSlingshotOrDomain(garageItem: Garageable): false | string {
        if (
            garageItem.isSlingshot ||
            garageItem.isOnBrand?.('SLG') ||
            (garageItem.brand === 'gem' && garageItem.appSku === 'SLG')
        ) {
            return this.routingHelpersService.combineUrl(
                this.configService.rideCommandUrl.slingshot,
                this.configService.baseHref
            );
        }
        return false;
    }
}
